import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SicherheitPage from "../pages/article/Sicherheit";
import VersandPage from "../pages/article/Versand";
import QCGuidePage from "../pages/article/QCGuide";
import VergleichPage from "../pages/article/Vergleich";
import AnfaengerPage from "../pages/article/Anfaenger";
import TrendproduktePage from "../pages/article/Trendprodukte";
import VerkauferPage from "../pages/article/Verkaufer";
import KostenSparenPage from "../pages/article/KostenSparen";
import FAQPage from "../pages/article/FAQ";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/oopbuy-sicherheit",
    element: <SicherheitPage />,
  },
  {
    path: "/oopbuy-versand",
    element: <VersandPage />,
  },
  {
    path: "/oopbuy-qc-guide",
    element: <QCGuidePage />,
  },
  {
    path: "/oopbuy-vergleich",
    element: <VergleichPage />,
  },
  {
    path: "/oopbuy-anfaenger",
    element: <AnfaengerPage />,
  },
  {
    path: "/oopbuy-trendprodukte",
    element: <TrendproduktePage />,
  },
  {
    path: "/oopbuy-verkaufer",
    element: <VerkauferPage />,
  },
  {
    path: "/oopbuy-kosten-sparen",
    element: <KostenSparenPage />,
  },
  {
    path: "/oopbuy-faq",
    element: <FAQPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;